import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import texts from './texts';
import errorBar from './error';
import calculationData from './calculation-data';
import templateData from './get-template-data';
import loading from './loading';
import summary from './summary';
import step from './step';

export default combineReducers({
    texts,
    errorBar,
    calculationData,
    loading,
    templateData,
    summary,
    step,
    routing: routerReducer,
    form: formReducer
});
